import { Provider } from 'react-redux'
import React from 'react'

import store from '../store/store'

// Whenever you use component via packs, use this App component as parent to use redux.
// e.g. <App><HeartButton/></App>
const App = (props) => {
  // NOTE: we pass initiall state via Rails view(in application.html.haml). 
  // ApplicationHelper "store_data" returns data for for initial state.
  const node = document.getElementById('initial-redux-store')
  const initialState = JSON.parse(node.getAttribute('data'))

  return (
    <Provider store={store(initialState)}>
      {props.children}
    </Provider>
  )
}

export default App